export const PATH_TO_BANNER_MAP = {
    '/campaigns/list'      : 'campaigns',
    '/campaigns/statistics': 'statistics',
    '/campaigns/finances'  : 'finances',
    '/campaigns/news'      : 'news',
    '/campaigns/help'      : 'help',
    '/campaigns/promotions': 'promotions'
};
